var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"salaryTotal"}},[_c('van-nav-bar',{attrs:{"title":"数据展示","right-text":"刷新","left-arrow":"","left-text":"返回"},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }